<template>
	<div class="page">
		<div class="header">
			<van-icon name="arrow-left" class="return" size="28" @click="goBack" />
			<div class="logo-group">
				<img src="../assets/images/logo/logo2.png" alt="中国联通" class="logo-img" />
			</div>
		</div>
		<div class="info">
			<div class="sub-title">温馨提示</div>
			<p class="greeting">尊敬的合作伙伴，</p>
			<p class="intro">您好!感谢您对本次会议的关注。为确保您顺利参会特向您作以下温馨提示:</p>

			<div class="section">
				<div class="section-title">参会凭证</div>
				<p class="section-content">打开会议小程序，在签到页面输入手机号并填写短信验证码即视为签到成功，凭签到成功页面在会场签到处领取嘉宾证</p>
			</div>
			<div class="section">
				<div class="section-title">伴手礼与午餐券领取</div>
				<p class="section-content">伴手礼已提前发放至会场座位。<br/>餐券附在嘉宾证反面，请按餐券上的地址自行前往餐厅用餐。</p>
			</div>

			<div class="section">
				<div class="section-title">停车提示</div>
				<div class="parking-row">
					<ul class="section-list">
						<li>导航搜索：富力万达嘉华地下停车场（入口），此入口在东湖路与松竹路交叉口西南40米处</li>
						<li>统一停车：停至地下停车场 B1 层，通过直梯直达 3 楼，也可在 1 楼下车，通过地面入口进入，通过扶梯达到 3 楼</li>
						<li>停车券:签到处旁将放置免费停车二维码，会议结束时大屏也将投屏免费停车二维码，请自行拍摄保存，离开停车场时扫描二维码即可免费停车。</li>
					</ul>
					<!-- <div class="map">
						<img src="../assets/images/flat.png" class="responsive-map" />
					</div> -->
				</div>
			</div>

			<div class="section">
				<div class="section-title">其他注意事项</div>
				<ul class="section-list">
					<li>会议将于9：00正式开始，请务必提前入场签到，以免耽误会议议程。</li>
					<!-- <li><strong>着装建议:</strong>着装建议：着装得体、大方即可</li> -->
					<!-- <li><strong>餐饮安排:</strong>会议期间提供午餐,午餐地点位于酒店一楼美食汇全日餐厅,用餐时间为11:00—13:00,请您留意时间。</li> -->
				</ul>
			</div>

			<!-- <p class="closing">如有任何疑问,请联系对应的采购工程师!</p> -->
			<p class="closing">期待与您相聚,共襄盛会!</p>
		</div>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const goBack = () => {
	router.back();
};
</script>

<style scoped>
.page {
	width: 100vw;
	min-height: 100vh; /* 使用 min-height 代替 height */
	background: url("../assets/bg/718.jpg") 100% 100% no-repeat;
	background-size: cover;
	background-attachment: fixed; /* 固定背景 */
}

p{
	margin: 0;
}

.page::after {
	content: "";
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	height: 35%;
	background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M0,60 C300,120 600,0 900,60 C1050,90 1150,60 1200,60 L1200,120 L0,120 Z' fill='rgba(56,189,248,0.08)'/%3E%3Cpath d='M0,80 C400,20 800,100 1200,80 L1200,120 L0,120 Z' fill='rgba(255,255,255,0.05)'/%3E%3Cpath d='M0,100 C250,70 750,110 1200,100 L1200,120 L0,120 Z' fill='rgba(56,189,248,0.06)'/%3E%3C/svg%3E") no-repeat bottom center;
	background-size: 100% auto;
	pointer-events: none;
	z-index: 0;
}

.header {
	align-items: center;
	padding: 16px 12px 12px;
	gap: 12px;
	position: relative;
	z-index: 1;
}

.return {
	color: #fff;
	padding: 8px;
	border-radius: 5px;
	cursor: pointer;
	flex-shrink: 0;
}


.logo-img {
	width: 55%;
    height: auto;
    display: block;
    margin: auto;
    padding: 8px;
}

.theme-logo {
	width: 70px;
	height: 28px;
	background: url("../assets/images/theme.png") no-repeat center center;
	background-size: contain;
}

.sub-title {
	font-size: 18px;
	font-weight: bold;
	/* color: #FAFBFE; */
	text-align: left;
	margin-bottom: 12px;
	position: relative;
	z-index: 1;
}

.info {
	width: 95%;
	margin: 0 auto;
	border-radius: 16px;
	padding: 10px 10px 20px;
	box-shadow: 0 4px 24px rgba(236, 219, 219, 0.12);
	position: relative;
	z-index: 1;
	box-sizing: border-box;
	font-size: 10px;
}

.greeting {
	/* color: #FAFBFE; */
	font-size: 12px;
}

.intro {
	/* color: #FAFBFE; */
	font-size: 12px;
	line-height: 1.6;
	margin: 0 0 16px;
	text-indent: 2em;
}

.section {
	margin-bottom: 16px;
}

.section-title {
	display: inline-block;
	position: relative;
	color: #fff;
	font-size: 15px;
	font-weight: bold;
	padding: 2px 20px 2px 18px;
	background-color: #38bdf8;
	clip-path: polygon(0 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
}

.section-title::before {
	content: "";
	position: absolute;
	left: 6px;
	top: 50%;
	transform: translateY(-50%);
	width: 0;
	height: 0;
	border: 4px solid transparent;
	border-left-color: rgba(255, 255, 255, 0.6);
}

.section-content {
	/* color: #FAFBFE; */
	font-size: 12px;
	line-height: 1.6;
	margin: 6px 0;
}

.section-list {
	/* color: #FAFBFE; */
	font-size: 12px;
	line-height: 1.6;
	margin: 6px 0;
	padding-left: 18px;
}

.section-list li {
	margin-bottom: 6px;
	position: relative;
	text-align: left;
}

.section-list li::before {
	content: "●";
	display: inline-block;
	width: 1em;
	margin-right: 4px;
	/* color: #FAFBFE; */
	font-size: 8px;
	vertical-align: middle;
}

.parking-row {
	display: flex;
	gap: 12px;
	align-items: flex-start;
	margin-top: 8px;
}

.parking-row .section-list {
	flex: 0.9;
	min-width: 0;
}

.parking-row .map {
	flex: 1.1;
	width: 130px;
	border: 1px solid rgba(56, 189, 248, 0.4);
	border-radius: 8px;
	overflow: hidden;
}

.closing {
	/* color: #FAFBFE; */
	font-size: 12px;
	margin: 12px 0 6px;
	padding-left: 18px;
}

.signature {
	/* color: #FAFBFE; */
	font-size: 12px;
	text-align: right;
	margin-top: 24px;
	line-height: 2;
}


.responsive-map {
	height: 170px;
	width: 100%;
}
.qrCode {
    display: flex;
    margin-top: 10px;
}
.qrCode img {
    width: 80px;
    height: auto;
    margin: 0 auto;
}
.apply {
	width: 150px;
	height: 40px;
	/* height: auto; */
	background-image: url("../assets/images/apply.png"); /* 替换为你的背景图片路径 */
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: auto;
	margin-top: 15px;
	color: #071beb;
	font-weight: bold;
}
</style>
